// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Log$SmartcutsMacros = require("../Log.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../../bs-utils/src/ArrayUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");
var Browser__Debugger$SmartcutsMacros = require("../browser/Browser__Debugger.bs.js");

var nodeId_encode = Decco.intToJson;

var nodeId_decode = Decco.intFromJson;

var backendNodeId_encode = Decco.intToJson;

var backendNodeId_decode = Decco.intFromJson;

var $$Node = {};

var methodName = "DOM.resolveNode";

var Params = {};

var Result = {};

var ResolveNode = {
  methodName: methodName,
  Params: Params,
  Result: Result
};

function resolveNode(backendNodeId, executionContextId, nodeId, objectGroup, tabId, extensionId, targetId, param) {
  var tmp = {};
  if (backendNodeId !== undefined) {
    tmp.backendNodeId = Caml_option.valFromOption(backendNodeId);
  }
  if (executionContextId !== undefined) {
    tmp.executionContextId = Caml_option.valFromOption(executionContextId);
  }
  if (nodeId !== undefined) {
    tmp.nodeId = Caml_option.valFromOption(nodeId);
  }
  if (objectGroup !== undefined) {
    tmp.objectGroup = Caml_option.valFromOption(objectGroup);
  }
  var params = tmp;
  return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, methodName, params).then(function (result) {
              return Promise.resolve(OptionUtils$SmartcutsMacros.$neg$question$great(result, (function (prim) {
                                return prim.object;
                              })));
            });
}

var methodName$1 = "DOM.requestNode";

var Params$1 = {};

var Result$1 = {};

var RequestNode = {
  methodName: methodName$1,
  Params: Params$1,
  Result: Result$1
};

function requestNode(objectId, tabId, extensionId, targetId, param) {
  var params = {
    objectId: objectId
  };
  return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, methodName$1, params).then(function (maybeResult) {
              return Promise.resolve(OptionUtils$SmartcutsMacros.map(maybeResult, (function (result) {
                                return result.nodeId;
                              })));
            });
}

var GetAttributes = {};

function getAttributes(nodeId, tabId, extensionId, targetId, param) {
  var params = {
    nodeId: nodeId
  };
  return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, "DOM.getAttributes", params).then(function (result) {
              if (result !== undefined) {
                return Promise.resolve(Belt_Array.reduce(ArrayUtils$SmartcutsMacros.groupIntoPairs(result.attributes), undefined, (function (map, param) {
                                  return Belt_MapString.set(map, param[0], param[1]);
                                })));
              } else {
                return Promise.resolve(undefined);
              }
            });
}

var SetAttributeValue = {};

function setAttributeValue(nodeId, name, value, tabId, extensionId, targetId, param) {
  var params = {
    nodeId: nodeId,
    name: name,
    value: value
  };
  return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, "DOM.setAttributeValue", params).then(function (param) {
              return Promise.resolve(undefined);
            });
}

var RemoveAttribute = {};

function removeAttribute(nodeId, name, tabId, extensionId, targetId, param) {
  var params = {
    nodeId: nodeId,
    name: name
  };
  return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, "DOM.removeAttribute", params).then(function (param) {
              return Promise.resolve(undefined);
            });
}

var Params$2 = {};

var Result$2 = {};

var All = {};

var QuerySelector = {
  Params: Params$2,
  Result: Result$2,
  All: All
};

function querySelector(nodeId, selector, tabId, extensionId, targetId, param) {
  var params = {
    nodeId: nodeId,
    selector: selector
  };
  return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, "DOM.querySelector", params).then(function (result) {
              var nodeId = OptionUtils$SmartcutsMacros.$neg$question$great(result, (function (prim) {
                      return prim.nodeId;
                    }));
              if (nodeId !== undefined && nodeId !== 0) {
                return Promise.resolve(nodeId);
              } else {
                return Promise.resolve(undefined);
              }
            });
}

function querySelectorAll(nodeId, selector, tabId, extensionId, targetId, param) {
  var params = {
    nodeId: nodeId,
    selector: selector
  };
  return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, "DOM.querySelectorAll", params).then(function (result) {
              if (result !== undefined) {
                return Promise.resolve(result.nodeIds);
              } else {
                return Promise.resolve([]);
              }
            });
}

function enable(tabId, extensionId, targetId, param) {
  return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, "DOM.enable", undefined).then(function (param) {
              return Promise.resolve(undefined);
            });
}

var methodName$2 = "DOM.performSearch";

var Params$3 = {};

var Result$3 = {};

var PerformSearch = {
  methodName: methodName$2,
  Params: Params$3,
  Result: Result$3
};

function performSearch(tabId, extensionId, targetId, includeUserAgentShadowDOM, query, param) {
  return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, methodName$2, {
              query: query,
              includeUserAgentShadowDOM: includeUserAgentShadowDOM
            });
}

var methodName$3 = "DOM.getSearchResults";

var Params$4 = {};

var Result$4 = {};

var GetSearchResults = {
  methodName: methodName$3,
  Params: Params$4,
  Result: Result$4
};

function getSearchResults(tabId, extensionId, targetId, searchId, fromIndex, toIndex, param) {
  return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, methodName$3, {
              searchId: searchId,
              fromIndex: fromIndex,
              toIndex: toIndex
            });
}

function toInt(depth) {
  if (depth) {
    return depth._0;
  } else {
    return -1;
  }
}

var Depth = {
  toInt: toInt
};

var Params$5 = {};

var Result$5 = {};

var GetDocument = {
  Params: Params$5,
  Result: Result$5
};

function getDocument(depthOpt, pierce, tabId, extensionId, targetId, param) {
  var depth = depthOpt !== undefined ? depthOpt : /* TreeDepth */({
        _0: 1
      });
  var tmp = {
    depth: toInt(depth)
  };
  if (pierce !== undefined) {
    tmp.pierce = Caml_option.valFromOption(pierce);
  }
  var params = tmp;
  return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, "DOM.getDocument", params).then(function (result) {
              return Promise.resolve(OptionUtils$SmartcutsMacros.$neg$question$great(result, (function (prim) {
                                return prim.root;
                              })));
            });
}

function centerPoint(param) {
  return [
          (param[0] + param[4]) / 2.0 | 0,
          (param[1] + param[5]) / 2.0 | 0
        ];
}

var $$Location = {
  centerPoint: centerPoint
};

var Params$6 = {};

var Result$6 = {};

var GetContentQuads = {
  Params: Params$6,
  Result: Result$6
};

function getContentQuads(tabId, extensionId, targetId, nodeId, backendNodeId, param) {
  var tmp = {};
  if (nodeId !== undefined) {
    tmp.nodeId = Caml_option.valFromOption(nodeId);
  }
  if (backendNodeId !== undefined) {
    tmp.backendNodeId = Caml_option.valFromOption(backendNodeId);
  }
  var params = tmp;
  return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, "DOM.getContentQuads", params).catch(function (e) {
                Curry._2(Log$SmartcutsMacros.cdp.log2, "getContentQuads", e);
                return Promise.resolve(undefined);
              }).then(function (result) {
              var quads = OptionUtils$SmartcutsMacros.$neg$question$great(result, (function (prim) {
                      return prim.quads;
                    }));
              if (quads !== undefined) {
                return Promise.resolve(quads);
              } else {
                return Promise.resolve([]);
              }
            });
}

var Params$7 = {};

var Result$7 = {};

var DescribeNode = {
  Params: Params$7,
  Result: Result$7
};

function describeNode(nodeId, backendNodeId, objectId, depthOpt, pierce, tabId, extensionId, targetId, param) {
  var depth = depthOpt !== undefined ? depthOpt : /* TreeDepth */({
        _0: 1
      });
  var tmp = {
    depth: toInt(depth)
  };
  if (nodeId !== undefined) {
    tmp.nodeId = Caml_option.valFromOption(nodeId);
  }
  if (backendNodeId !== undefined) {
    tmp.backendNodeId = Caml_option.valFromOption(backendNodeId);
  }
  if (objectId !== undefined) {
    tmp.objectId = Caml_option.valFromOption(objectId);
  }
  if (pierce !== undefined) {
    tmp.pierce = Caml_option.valFromOption(pierce);
  }
  var params = tmp;
  return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, "DOM.describeNode", params).then(function (result) {
              return Promise.resolve(OptionUtils$SmartcutsMacros.map(result, (function (result) {
                                return result.node;
                              })));
            });
}

var Params$8 = {};

var Result$8 = {};

var GetOuterHTML = {
  Params: Params$8,
  Result: Result$8
};

function getOuterHTML(nodeId, backendNodeId, objectId, tabId, extensionId, targetId, param) {
  var tmp = {};
  if (nodeId !== undefined) {
    tmp.nodeId = Caml_option.valFromOption(nodeId);
  }
  if (backendNodeId !== undefined) {
    tmp.backendNodeId = Caml_option.valFromOption(backendNodeId);
  }
  if (objectId !== undefined) {
    tmp.objectId = Caml_option.valFromOption(objectId);
  }
  var params = tmp;
  return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, "DOM.getOuterHTML", params).then(function (result) {
              return Promise.resolve(OptionUtils$SmartcutsMacros.$neg$question$great(result, (function (prim) {
                                return prim.outerHTML;
                              })));
            });
}

var ShapeOutsideInfo = {};

var BoxModel = {};

var Params$9 = {};

var Result$9 = {};

var GetBoxModel = {
  Params: Params$9,
  Result: Result$9
};

function getBoxModel(nodeId, backendNodeId, objectId, tabId, extensionId, targetId, param) {
  var tmp = {};
  if (nodeId !== undefined) {
    tmp.nodeId = Caml_option.valFromOption(nodeId);
  }
  if (backendNodeId !== undefined) {
    tmp.backendNodeId = Caml_option.valFromOption(backendNodeId);
  }
  if (objectId !== undefined) {
    tmp.objectId = Caml_option.valFromOption(objectId);
  }
  var params = tmp;
  return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, "DOM.getBoxModel", params).then(function (maybeResult) {
              return Promise.resolve(OptionUtils$SmartcutsMacros.map(maybeResult, (function (result) {
                                return result.model;
                              })));
            });
}

var methodName$4 = "DOM.getNodeForLocation";

var Params$10 = {};

var Result$10 = {};

var GetNodeForLocation = {
  methodName: methodName$4,
  Params: Params$10,
  Result: Result$10
};

function getNodeForLocation(x, y, includeUserAgentShadowDOM, ignorePointerEventsNone, tabId, extensionId, targetId, param) {
  var tmp = {
    x: x,
    y: y
  };
  if (includeUserAgentShadowDOM !== undefined) {
    tmp.includeUserAgentShadowDOM = Caml_option.valFromOption(includeUserAgentShadowDOM);
  }
  if (ignorePointerEventsNone !== undefined) {
    tmp.ignorePointerEventsNone = Caml_option.valFromOption(ignorePointerEventsNone);
  }
  var params = tmp;
  return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, methodName$4, params);
}

var methodName$5 = "DOM.scrollIntoViewIfNeeded";

var Params$11 = {};

var ScrollIntoViewIfNeeded = {
  methodName: methodName$5,
  Params: Params$11
};

function scrollIntoViewIfNeeded(nodeId, backendNodeId, objectId, rect, tabId, extensionId, targetId, param) {
  var tmp = {};
  if (nodeId !== undefined) {
    tmp.nodeId = Caml_option.valFromOption(nodeId);
  }
  if (backendNodeId !== undefined) {
    tmp.backendNodeId = Caml_option.valFromOption(backendNodeId);
  }
  if (objectId !== undefined) {
    tmp.objectId = Caml_option.valFromOption(objectId);
  }
  if (rect !== undefined) {
    tmp.rect = Caml_option.valFromOption(rect);
  }
  var params = tmp;
  return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, methodName$5, params).then(function (param) {
              return Promise.resolve(undefined);
            });
}

var RGBA = {};

var Rect;

exports.nodeId_encode = nodeId_encode;
exports.nodeId_decode = nodeId_decode;
exports.backendNodeId_encode = backendNodeId_encode;
exports.backendNodeId_decode = backendNodeId_decode;
exports.$$Node = $$Node;
exports.Rect = Rect;
exports.ResolveNode = ResolveNode;
exports.resolveNode = resolveNode;
exports.RequestNode = RequestNode;
exports.requestNode = requestNode;
exports.GetAttributes = GetAttributes;
exports.getAttributes = getAttributes;
exports.SetAttributeValue = SetAttributeValue;
exports.setAttributeValue = setAttributeValue;
exports.RemoveAttribute = RemoveAttribute;
exports.removeAttribute = removeAttribute;
exports.QuerySelector = QuerySelector;
exports.querySelector = querySelector;
exports.querySelectorAll = querySelectorAll;
exports.enable = enable;
exports.PerformSearch = PerformSearch;
exports.performSearch = performSearch;
exports.GetSearchResults = GetSearchResults;
exports.getSearchResults = getSearchResults;
exports.Depth = Depth;
exports.GetDocument = GetDocument;
exports.getDocument = getDocument;
exports.$$Location = $$Location;
exports.GetContentQuads = GetContentQuads;
exports.getContentQuads = getContentQuads;
exports.DescribeNode = DescribeNode;
exports.describeNode = describeNode;
exports.GetOuterHTML = GetOuterHTML;
exports.getOuterHTML = getOuterHTML;
exports.ShapeOutsideInfo = ShapeOutsideInfo;
exports.BoxModel = BoxModel;
exports.GetBoxModel = GetBoxModel;
exports.getBoxModel = getBoxModel;
exports.GetNodeForLocation = GetNodeForLocation;
exports.getNodeForLocation = getNodeForLocation;
exports.ScrollIntoViewIfNeeded = ScrollIntoViewIfNeeded;
exports.scrollIntoViewIfNeeded = scrollIntoViewIfNeeded;
exports.RGBA = RGBA;
/* Log-SmartcutsMacros Not a pure module */
